module.exports = __webpack_public_path__ + "img/platform-external-32.a935aa78.svg";